import { render, staticRenderFns } from "./PM25RecordList.vue?vue&type=template&id=90d2945a&scoped=true&"
import script from "./PM25RecordList.vue?vue&type=script&lang=js&"
export * from "./PM25RecordList.vue?vue&type=script&lang=js&"
import style0 from "./PM25RecordList.vue?vue&type=style&index=0&id=90d2945a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2945a",
  null
  
)

export default component.exports